import { render, staticRenderFns } from "./LineItem5.vue?vue&type=template&id=a9b88990&scoped=true&"
import script from "./LineItem5.vue?vue&type=script&lang=js&"
export * from "./LineItem5.vue?vue&type=script&lang=js&"
import style0 from "./LineItem5.vue?vue&type=style&index=0&id=a9b88990&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b88990",
  null
  
)

export default component.exports